/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { getAllUsersData } from 'src/services/userService';
import type { SavedReport, SaveShareToUser, SharedUsersType, UserIdsArray } from '../types/types';
import { shareReportToUsers } from 'src/services/sharedReportService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';

interface PropsType {
    reportData?: SavedReport;
    refreshPage: () => void;
    onClose: () => void;
}

interface UserListPropType {
    "id": number;
    "firstName": string;
    "lastName": string;
    "email": string;
    "password": string | null;
    "isDeleted": boolean;
    "isActive": boolean;
    "createdBy": number;
    "createdOn": string;
    "updatedBy": number;
    "updatedOn": string;
    "deletedBy": string | null;
    "deletedOn": string | null;
    "role": string;
}

interface ApiResponse {
    status: number;
    data: {
        data: UserListPropType[];
    };
}

interface SaveApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };

}

function UserListModal({ reportData, refreshPage, onClose }: PropsType): JSX.Element {
    const [userList, setUserList] = useState<UserListPropType[]>([])
    const [selectedUserId, setSelectedUserId] = useState<UserIdsArray[]>([])
    const [selectedUserIds, setSelectedUserIds] = useState<number[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isUserLoading, setIsUserLoading] = useState<boolean>(false)

    useEffect(() => {
        setIsUserLoading(true)
        getAllUsersData()
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        console.log(res)
                        const userListArr: UserListPropType[] =[];

                        res.data.data.map((user:UserListPropType) => {
                            if(user.isActive) {
                                userListArr.push(user)
                            }
                        })
                        setUserList(userListArr)

                    }
                }
            )
            .catch(
                error => console.log("Error in fetching users: ", error)
            )
            .finally(() => {
                setIsUserLoading(false)
            })

        const userIds: number[] = [];
        const userIdArr: UserIdsArray[] = []
        reportData?.sharedUsers.map(
            (data: SharedUsersType) => {
                if (data.userId !== 0 && data.sharedFirstName !== null) {
                    userIds.push(data.userId)
                    userIdArr.push({ userId: data.userId })
                    
                }
            }
        )
        setSelectedUserId(userIdArr);
        setSelectedUserIds(userIds);
    }, [])

    const handleSelect = (event: React.ChangeEvent<HTMLInputElement>, userId: number): void => {
        const { target } = event
        if (target.checked === true) {
            setSelectedUserId([...selectedUserId, { userId: userId }])
            setSelectedUserIds([...selectedUserIds, userId])
        } else {
            const data: UserIdsArray[] = selectedUserId.filter((user: UserIdsArray) => user.userId !== userId)
            const userIdArr: number[] = selectedUserIds.filter((id: number) => id !== userId)
            console.log("dataxx=", data)
            setSelectedUserId(data.length > 0 ? data : [{userId: 1000000}])
            setSelectedUserIds(userIdArr)
        }
    }

    const handleShare = (): void => {
        setIsLoading(true)

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const date: Date = new Date();
        const data: SaveShareToUser = {
            "dashboardFilterId": reportData ? reportData.dashboardFilterId : 0,
            "dashboardId": reportData ? reportData.dashboardId : 0,
            "userList": selectedUserId,
            "sharedOn": date.toISOString(),
            "sharedBy": reportData ? reportData.userId : 0,
        }
        
        if (selectedUserId.length > 0) {
            shareReportToUsers(data)
                .then(
                    (res: SaveApiResponse) => {
                        if (res.status === 200) {
                            if (res.data.result === 1) {
                                console.log("shared")
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                                NotificationManager.success("Report shared successfully")
                                refreshPage()
                            }
                        }
                    }
                )
                .catch(
                    error => console.log("Error in share report: ", error)
                )
                .finally(() => {
                    setIsLoading(false)
                    console.log("Report shared successfully")
                })
        } else {
            setIsLoading(false)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            NotificationManager.error("Please select users to share the report")
        }
    }

    const handleClose = (): void => {
        onClose()
    }

    return (
        <>
            {
                isUserLoading ? <div className='flex justify-center items-center relative top-[20%]'><span className="loading loading-spinner text-primary"></span></div> :
                    <React.Fragment>
                        <ul className='px-[24px] mb-[65px]'>
                            {
                                userList.length > 0 && userList.map(
                                    (user: UserListPropType) => (
                                        <li key={user.id} className='py-5 border-b-[1px] border-[#D9D9D9]'>
                                            <div className='grid grid-cols-2'>
                                                <div className='col-span-1'>
                                                    <div className="form-control">
                                                        <label className={`cursor-pointer flex items-center`}>
                                                            <input type="checkbox" className="checkbox" onChange={(e) => handleSelect(e, user.id)} checked={selectedUserIds.includes(user.id)} />
                                                            <span className="text-muted text-14 font-normal">{`${user.firstName} ${user.lastName}`}</span>

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                )
                            }
                        </ul>
                        <div className="flex items-center fixed left-0 bottom-0 w-[100%]">
                            <button type="button" className="w-[50%] bg-white h-[55px] border border-inputborder text-muted flex font-semibold text-[15px] items-center justify-center" disabled={isLoading} onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="submit" className="w-[50%] h-[55px] bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[55px text-white flex font-semibold text-[15px] items-center justify-center" onClick={handleShare} disabled={isLoading}>
                                {!isLoading ? 'Share' : <span className="loading loading-spinner loading-xs text-white"></span>}
                            </button>
                        </div>
                    </React.Fragment>
            }
        </>
    )
}

export default UserListModal